import PulseTimelapse from "./PulseTimelapse";
import type {
  PulseData,
  PulseGraphData,
  PulsePostDataObject,
} from "../../types/pulse.types";

interface PulseBentoProps {
  mainPulse?: PulseData | null;
  pulseCards?: PulseData[];
  graphData?: PulseGraphData | null;
  postData?: PulsePostDataObject | null;
  onGraphDurationChange?: (duration: string) => void;
  onShowJSON?: (pulseId: string) => void;
  onOpenJSON?: (pulseId: string) => void;
  onShowTimelapse?: (pulseId: string) => void;
}

export default function PulseBento({
  mainPulse,
  graphData,
  postData,
  onGraphDurationChange = () => {},
  onShowJSON = () => {},
}: PulseBentoProps) {
  if (!mainPulse) {
    return (
      <div className="flex w-full items-center justify-center py-8">
        <div className="text-neutral-600">No pulse data available</div>
      </div>
    );
  }

  return (
    <div className="flex w-full">
      <PulseTimelapse
        pulse={mainPulse}
        graphData={graphData}
        postData={postData}
        onGraphDurationChange={onGraphDurationChange}
        onShowJSON={() => onShowJSON(mainPulse._id)}
      />
    </div>
  );
}
